<template>
  <div id="radarMap">
    <div id="aibenMap"></div>
    <div class="map-pos">
      <div>{{ total }}</div>
      <div>健康值</div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import API from "../../utils/axiosApi/aibenApi";
import { getUserInfo } from "../../assets/js/common";
export default {
  name: "radarMap",
  data() {
    return {
      sixIcon: {},
      total:""
    };
  },
  methods: {
    // 获取雷达图数据
    getIconData() {
      API.getSixIconData({ crmId: getUserInfo() }, (res) => {
        if (res.code == 200) {
          this.sixIcon = res.data;
          this.total = res.data.totalScore;
        } else {
          this.total = "--";
          this.sixIcon.immunity = 0;
          this.sixIcon.gastrointestinal = 0;
          this.sixIcon.angiocarpy = 0;
          this.sixIcon.bloodGlucose = 0;
          this.sixIcon.skeleton = 0;
          this.sixIcon.sleep = 0;
        }
        var chartDom = document.getElementById("aibenMap");
        var myChart = echarts.init(chartDom);
        var option;
        option = {
          color: ["#fff", "#36584e", "#295044", "#1B463A"],
          title: {
            // text: 'Customized Radar Chart'
          },
          legend: {},
          radar: [
            {
              indicator: [
                { text: "免疫力", max: 100 },
                { text: "肠胃道", max: 100 },
                { text: "心血管", max: 100 },
                { text: "血糖", max: 100 },
                { text: "骨骼", max: 100 },
                { text: "睡眠", max: 100 },
              ],
              center: ["47%", "50%"],
              radius: 69,
              startAngle: 30,
              splitNumber: 4,
              shape: "circle",
              name: {
                formatter: "{value}",
                textStyle: {
                  color: "#fff",
                },
                fontSize: 9,
                padding: -12,
              },

              splitArea: {
                areaStyle: {
                  color: ["#fff", "#36584e", "#295044", "#1B463A"],
                  shadowColor: "rgba(0, 0, 0, 0.2)",
                  shadowBlur: 10,
                },
              },
              axisLine: {
                lineStyle: {
                  color: "#36584e",
                },
              },
              splitLine: {
                interval: 3,
                lineStyle: {
                  color: "rgba(48,88,78,.8)",
                },
              },
            },
          ],
          series: [
            {
              type: "radar",
              emphasis: {
                lineStyle: {
                  width: 4,
                },
              },
              data: [
                {
                  value: [
                    this.sixIcon.immunity,
                    this.sixIcon.gastrointestinal,
                    this.sixIcon.angiocarpy,
                    this.sixIcon.bloodGlucose,
                    this.sixIcon.skeleton,
                    this.sixIcon.sleep,
                  ],
                  areaStyle: {
                    color: "rgba(255, 223, 167, 1)",
                  },
                  // name: 'Data A'
                },
              ],
              lineStyle: {
                width: 1,
                opacity: 0.5,
                color: "rgba(255, 223, 167, 1)",
              },
              symbolSize: 1,
            },
          ],
        };

        option && myChart.setOption(option);
      });
    },
  },
  created() {
    this.getIconData();
  },
  mounted() {
    this.getIconData();
  },
};
</script>

<style lang="less" scoped>
#radarMap {
  height: 100%;
  position: relative;

  #aibenMap {
    width: 100%;
    height: 100%;
  }

  .map-pos {
    position: absolute;
    width: 69px;
    height: 69px;
    border-radius: 50%;
    background: #ffffff;
    left: 58px;
    top: 51px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    :first-child {
      height: 34px;
      line-height: 34px;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: normal;
      color: #dba566;
    }
    :nth-child(2) {
      font-size: 10px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 400;
      color: #dba566;
    }
  }
}
</style>